import { DOCS_FORM_NAMES } from "core/consts";
import type { PdfCreatorProps } from "../..";
import { FieldConfig, createDischargeLetterPdf } from "../pdfCreationUtils";

export const OBSTETRICS_FIELD_CONFIG: Array<
  FieldConfig<typeof DOCS_FORM_NAMES.DISCHARGE_LETTER_OBSTETRICS>
> = [
  {
    key: "diagnoses",
    label: (translations) =>
      translations.extractDocs.dischargeLetter.formFieldNames.diagnoses,
  },
  {
    key: "anamnesis",
    label: (translations) =>
      translations.extractDocs.dischargeLetter.formFieldNames.anamnesis,
  },
  {
    key: "physical_status",
    label: (translations) =>
      translations.extractDocs.dischargeLetter.formFieldNames.physicalStatus,
  },
  {
    key: "course_of_labor",
    label: (translations) =>
      translations.extractDocs.dischargeLetter.formFieldNames.courseOfLabour,
  },
  {
    key: "information_newborn",
    label: (translations) =>
      translations.extractDocs.dischargeLetter.formFieldNames
        .informationNewborn,
  },
  {
    key: "postpartum_recovery",
    label: (translations) =>
      translations.extractDocs.dischargeLetter.formFieldNames
        .postpartumRecovery,
  },
  {
    key: "discharge_status",
    label: (translations) =>
      translations.extractDocs.dischargeLetter.formFieldNames.dischargeStatus,
  },
  {
    key: "lab_results",
    label: (translations) =>
      translations.extractDocs.dischargeLetter.formFieldNames.labResults,
  },
  {
    key: "discharge_summary",
    label: (translations) =>
      translations.extractDocs.dischargeLetter.formFieldNames.dischargeSummary,
  },
  {
    key: "discharge_medications",
    label: (translations) =>
      translations.extractDocs.dischargeLetter.formFieldNames
        .dischargeMedications,
  },
  {
    key: "recommendations",
    label: (translations) =>
      translations.extractDocs.dischargeLetter.formFieldNames.recommendations,
  },
];

export function createObstetricsDischargeLetterPdf(
  props: PdfCreatorProps<typeof DOCS_FORM_NAMES.DISCHARGE_LETTER_OBSTETRICS>,
) {
  return createDischargeLetterPdf<
    typeof DOCS_FORM_NAMES.DISCHARGE_LETTER_OBSTETRICS
  >(props, OBSTETRICS_FIELD_CONFIG);
}
